<template>
    <div class="main">
        <topback title="Sell history" path="back"></topback>
        <md-tab-bar class="main-tab" v-model="current" :items="items" @change="onTabChange"></md-tab-bar>
        <md-swiper ref="swiper" :autoplay="0" :is-prevent="false" :is-loop="false" :has-dots="false"
            @before-change="onSwiperChange">
            <md-swiper-item>
                <sellhitorylist status="paying" v-if="status === 'paying'"></sellhitorylist>
            </md-swiper-item>
            <md-swiper-item>
                <sellhitorylist status="success" v-if="status === 'success'"></sellhitorylist>
            </md-swiper-item>
            <md-swiper-item>
                <sellhitorylist status="timeout" v-if="status === 'timeout'"></sellhitorylist>
            </md-swiper-item>
            <md-swiper-item>
                <sellhitorylist status="offline" v-if="status === 'offline'"></sellhitorylist>
            </md-swiper-item>
        </md-swiper>
    </div>
</template>

<script>
import topback from '@/components/topback'
import iconimg from '@/components/iconimg'
import sellhitorylist from '@/views/my/sellhitorylist'

export default {
    name: 'sell',
    components: {
        [topback.name]: topback,
        iconimg,
        sellhitorylist
    },
    data() {
        return {
            current: 0,
            items: [
                {name: 0, label: 'Paying', status: 'paying'},
                { name: 1, label: 'Success', status: 'success' },
                { name: 2, label: 'Timeout', status: 'timeout' },
                { name: 3, label: 'Offline', status: 'offline' }
            ],
            status: "paying",
            isPopupShow: {},
        }
    },
    created() {
    },
    methods: {
        onSwiperChange(from, to) {
            this.current = to
            let foundItem = this.items.find(item => item.name === to);
            this.status = foundItem.status;
			document.body.scrollTop = 0; // For Safari
			document.documentElement.scrollTop = 0;
		},
        onTabChange(item, index) {
			this.$refs.swiper.goto(index);
		},
        showPopUp(type) {
            this.$set(this.isPopupShow, type, true);
        },
        hidePopUp(type) {
            this.$set(this.isPopupShow, type, false);
        },
    }

}
</script>


<style scoped>
.main-tab {
    margin-top: 0.8rem;
}

.deposit-history .md-swiper {
	background: #FFF;
}

.deposit-history .md-swiper .md-swiper-item {
	padding: 20px;
	box-sizing: border-box;
	font-size: 24px;
	line-height: 1.5;
	color: #666;
}

</style>


// WEBPACK FOOTER //
// src/views/my/sellhistory.vue